import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-darkgray text-white py-4  border-t border-b border-orange-400">
      <div className="max-w-6xl mx-auto px-4 text-center">
        <p>&copy; {new Date().getFullYear()} Ilja's Portfolio. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
